import { fetcher } from "./auth.service";
import { CREATE_CARD_SESSION, CREATE_NEW_PAYMENT_METHOD, CREATE_NEW_TRANSACTION, LIST_ALL_TRANSATION_FOR_PROPERTY_MANAGER, LIST_ALL_TRANSATION_FOR_USERS, LIST_ALL_TRANSATION_FOR_USERS_FOR_CURRENT_STAY, TRANSACTION_INSITE_PM, TRANSACTION_INSITE_RENTER, UPDATE_PAYMENT_METHOD, VERIFY_PAYMENT_METHOD, VERIFY_STATUS_PAYMENT_METHOD } from "./base.service";

// The insite/property-manager transaction endpoints bucket results by the
// caller's local day, so they expect the browser's IANA timezone in x-timezone.
const timezoneHeader = () => ({
    "x-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone
});

export const updatePaymentMethod = async (id, paymentDetail) => {
    const data = await fetcher(
        UPDATE_PAYMENT_METHOD + "/" + id,
        "PATCH",
        paymentDetail,
        "application/json"
    )

    return data.json();
}

// Requests a short-lived, card-scoped Moov OAuth token (+ accountID + expiresOn)
// so the browser can tokenize the raw card via Moov.js Drops. Only the resulting
// cardID ever reaches our backend, keeping raw PAN/CVV out of our servers (PCI).
// The server derives the account from the JWT and ignores any body, so we send
// an empty object; data.expiresOn tells the caller when the token lapses.
export const createCardSession = async () => {
    const data = await fetcher(
        CREATE_CARD_SESSION,
        "POST",
        {},
        "application/json"
    )
    return data.json();
}

export const addPaymentMethod = async (paymentDetail) => {
    const data = await fetcher(
        CREATE_NEW_PAYMENT_METHOD ,
        "POST",
        paymentDetail,
        "application/json"
    )

    return data.json();
}

export const getPaymentMethodForUser = async (id, primary) => {
    const data = await fetcher(
        CREATE_NEW_PAYMENT_METHOD + "/user/" + id + (primary == "all" ? "" : "/primary"),
        'GET'
    )
    return data.json();
}
export const deletePaymentMethod = async (id) => {
    const data = await fetcher(CREATE_NEW_PAYMENT_METHOD + "/" + id,
        'DELETE'
    )
    return data.json();
}

export const verifyBankAccount = async (id, amounts) => {
    const data = await fetcher(
        VERIFY_PAYMENT_METHOD + "/" + id,
        "POST",
        { amounts },
        "application/json"
    )
    return data.json();
}

export const checkVerificationStatus = async (id) => {
    const data = await fetcher(
        VERIFY_STATUS_PAYMENT_METHOD + "/" + id,
        'GET'
    )
    return data.json();
}

export const getAllTrancationsForUser = async (id) => {
    const data = await fetcher(LIST_ALL_TRANSATION_FOR_USERS + "/" + id , 
        'GET'
    )
    return data.json();
}

export const getAllTrancationsForUserForCurrentProperty = async (id) => {
    const data = await fetcher(LIST_ALL_TRANSATION_FOR_USERS_FOR_CURRENT_STAY + "/" + id , 
        'GET'
    )
    return data.json();
}

export const renterTransactionInsite = async (id) => {
    const data = await fetcher(TRANSACTION_INSITE_RENTER + "/" + id ,
        'GET', null, "application/json", timezoneHeader()
    )
    return data.json();
}

export const pmTransactionInsite = async (id, duration = 3) => {
    const data = await fetcher(TRANSACTION_INSITE_PM + "/" + id + "/" + duration,
        'GET', null, "application/json", timezoneHeader()
    )
    return data.json();
}

export const createNewTransactionForUser = async (input) => {
    const data = await fetcher(
        CREATE_NEW_TRANSACTION ,
        "POST",
        input,
        "application/json"
    )
    return data.json();    
}


export const getAllTrancationsForPropertyManager = async (id, duration) => {
    const data = await fetcher(LIST_ALL_TRANSATION_FOR_PROPERTY_MANAGER + `/${id}/${duration}`,
        'GET', null, "application/json", timezoneHeader()
    )
    return data.json();
}